var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rank-item box"},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-md-4"},[_c('img',{staticClass:"img-circle img-fluid img-rank",attrs:{"src":_vm.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"text-white rank-name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"text-white rank-total"},[_vm._v(_vm._s(_vm.revenue))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23138afe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rank/RankItem.vue
// module id = null
// module chunks = 